/**
 * Pr0Unit — the PRO Work Units currency mark: "pr" + the prest0 logo as the
 * zero, with the inline metrics of the official brand lockup (BrandWordmark.tsx /
 * Header.tsx). The zero is the mark drawn inline (BrandMark): it sits on white cards,
 * dark chips and gold buttons, so its ink takes the colour of the words around it. 2026-08-13 owner directive: the
 * short form of PRO Work Units is pr0 (p-r-zero, logo zero) — never "WU",
 * never "w0". Use this component wherever the abbreviation renders in rich
 * UI (wallet balance, rate tile, amount rows); plain-text contexts
 * (aria-labels, CSV, copied strings) use the lowercase pr0 text form from
 * src/config/workUnits.ts.
 */

import React from 'react';
import styled from 'styled-components';
import BrandMark from './BrandMark';

const InlineLogo = styled(BrandMark)`
  display: inline-block;
  height: 1.02em;
  width: 1.0858em; /* 1.02em x 545/512: the mark's canvas */
  margin-left: -0.1em;
  margin-bottom: -0.13em;
  vertical-align: baseline;
`;

const Mark = styled.span`
  display: inline-block;
  line-height: 1;
  /* The img-zero must never wrap beneath "pr" under flex squeeze. */
  white-space: nowrap;
  letter-spacing: -0.02em;
`;

export const Pr0Unit: React.FC<{ className?: string }> = ({ className }) => (
  <Mark className={className} aria-label="pr0" role="img">
    pr<InlineLogo />
  </Mark>
);

export default Pr0Unit;
